import { TnAExtrahoursApprovalFilter } from "src/models/tna/tna-extra-hours/tna-extrahours-approval-filter";
import { TnAExtraHoursDTO, TnAExtraHoursSTO } from "../../models/tna";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class TnAExtraHoursApiService extends BaseApiService<TnAExtraHoursDTO, TnAExtraHoursSTO> {
  constructor() {
    super({
      servicePath: "/TnAExtraHours",
      loadItemsPath: "/GetTnAExtraHours", // not supposed to read items here, they will be read as part of timesheet or dashboard data
      saveItemsPath: "/SaveTnAExtraHours",
    });
  }
}

export const saveExtraHours = async (extrahours: TnAExtraHoursSTO) => {
  const response = await new TnAExtraHoursApiService().saveItems([extrahours]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};

export const approveExtraHours = async (
  employeeId: string,
  extrahourId: string,
  isApprovedRejected: "isApproved" | "isRejected"
) => {
  const extrahourToApproveReject = isApprovedRejected === "isApproved" ? "ApproveTnAExtraHours" : "RejectTnAExtraHours";

  const apiService = new TnAExtraHoursApiService();
  apiService.useLoadItemsPath(`/${extrahourToApproveReject}`);

  const response = await apiService.loadItems(
    {
      employeeId,
      extraHourIds: [extrahourId],
    } as TnAExtrahoursApprovalFilter,
    undefined,
    [],
    undefined,
    undefined,
    60
  );

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};
